<template>
  <v-container fluid grid-list-md px-0 py-1>
    <v-btn block large class="secondary timepicker-button" @focus="expanded=true" @keypress.stop="handleKeys">
      <div style="width:100%;position:relative;">
        <span style="left: 0; float: left;">{{label}}</span>
        <span style="float: right;">
          {{description}}
        </span>
      </div>
    </v-btn>
    <v-layout v-if="expanded" transition="expand" v-bind="orientation" wrap>
      <v-flex v-for="(button, i) in buttons" :key="i" xs12 md6>
        <v-btn block large v-bind:outline="!button.selected" v-bind:class="{primary: button.selected}" class="timepicker-button" @click="select(button)">{{button.label}}</v-btn>
      </v-flex>
      <v-layout xs12 row>
        <v-flex xs6 offset-md4 md2>
          <v-text-field style="text-align:right" class="text-xs-center display-1" ref="hour" type="number"
            single-line v-model="hour" outline @focus="$nextTick(() => $event.target.select())"></v-text-field>
        </v-flex>
        <v-flex xs6 md2>
          <v-text-field class="text-xs-center display-1" ref="minute" type="number"
            single-line v-model="minute" outline @focus="$nextTick(() => $event.target.select())"></v-text-field>
        </v-flex>
      </v-layout>
      <!-- <v-flex xs12 md8 lg7 xl6> -->
        <!-- <v-time-picker full-width v-bind:value="value" v-on:input="timepickerInput($event)"></v-time-picker> -->
      <!-- </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
export default {
  props: ['value', 'label', 'templates'],
  data: function () {
    return {
      expanded: false,
      buttons: []
    }
  },
  created: function () {
    moment.locale('rs')
    this.buttons.push({ label: `što pre`, arg: null, selected: this.value == null })
    for (let t of this.templates.split(',')) {
      this.buttons.push({ label: `za ${t} minuta`, arg: t })
    }
    // console.log('timepicker buttons', this.buttons)
  },
  methods: {
    select (button) {
      // console.log('select', button)
      this.buttons.forEach(b => { b.selected = (b.arg === button.arg) })
      this.$emit('input', button.arg != null ? moment().add(button.arg, 'minute').toDate() : button.arg)
    },
    timepickerInput (time) {
      let timepickerValue = moment(time, 'hh:mm')
      if (timepickerValue.isBefore()) {
        timepickerValue.add(1, 'day')
      }
      this.$emit('input', timepickerValue.toDate())
    },
    selectAll (e) {
      this.$nextTick(() => e.target.select())
    },
    normalize (m) {
      if (m.isBefore()) {
        m.add(1, 'day')
      } else if (moment(m).add(1, 'day').isAfter()) {
        m.subtract(1, 'day')
      }
    },
    handleKeys (event) {
      // console.log('handleKeys', event)
      if (this.expanded && (event.key === 'ArrowDown' || event.key === 'Tab')) {
        event.stopPropagation()
        event.preventDefault()
        for (let i in this.buttons) {
          if (this.buttons[i].selected) {
            this.select(this.buttons[++i % this.buttons.length])
            break
          }
        }
      } else if (this.expanded && event.key === 'ArrowUp') {
        event.stopPropagation()
        event.preventDefault()
        for (let i in this.buttons) {
          if (this.buttons[i].selected) {
            this.select(this.buttons[--i % this.buttons.length])
            break
          }
        }
      } else if (event.key === 'Enter') {
        this.expanded = !this.expanded
      }
    }
  },
  computed: {
    orientation () {
      return { column: !this.$vuetify.breakpoint.mdAndUp }
    },
    description () {
      if (this.value == null) {
        return 'što pre'
      } else {
        // return moment().to(this.value)
        return moment(this.value).format('HH:mm')
      }
    },
    hour: {
      get () {
        return this.value ? moment(this.value).format('HH') : ''
      },
      set (v) {
        let m = this.value ? moment(this.value) : moment()
        if (!isNaN(parseInt(v)) && +v >= 0 && +v <= 23) {
          m.hour(v)
        }
        this.normalize(m)
        this.$emit('input', m.toDate())
        if (v.length >= 2) {
          this.$refs.minute.focus()
        }
      }
    },
    minute: {
      get () {
        return this.value ? moment(this.value).format('mm') : ''
      },
      set (v) {
        let m = moment(this.value)
        if (!isNaN(parseInt(v)) && (+v >= 0) && (+v <= 59)) {
          m.minute(v)
        }
        this.normalize(m)
        this.$emit('input', m.toDate())
        if (v.length >= 2) {
          this.$refs.hour.focus()
        }
      }
    }
  }

}
</script>

<style scoped>
.expand-transition {
  transition: all .3s ease;
}
.v-input >>> input {
  text-align: center;
  padding: 0;
}
/* For Firefox */
.v-input >>> input[type='number'] {
  -moz-appearance:textfield;
}

/* Webkit browsers like Safari and Chrome */
.v-input >>> input[type=number]::-webkit-inner-spin-button,
.v-input >>> input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
